import { createContext } from 'react'
import { MessageWallController } from './MessageWallController'
import { CurrentUserEmojisController } from '@evertel/emojis'
import { APIDataRoom, APIDataThread } from '@evertel/types'

export interface MessageWallContextProps {
    repliesToId: number | null
    modelId: number
    modelType: 'room'|'thread'
    modelData: APIDataRoom|APIDataThread
    allowedToPost: boolean
    messageWallController: MessageWallController
    currentUserEmojisController: CurrentUserEmojisController
    setSelectedMessageId: (messageId: number) => void
    setIsReactedByModalOpen: (state: boolean) => void
    setIsReadByModalOpen: (state: boolean) => void
    setIsForwardMessageModalOpen: (state: boolean) => void
    setEmojiPickerState: ({visible, params}: {visible: boolean, params: Record<string, any>}) => void
    emojiPickerState: {visible: boolean, params?: Record<string, any>}
    selectedMessageId: number
    focusedMessageId?: number | null
    setFocusedMessageId?: (messageId: number | null) => void
    jumpToMessageId?: number | null
    setJumpToMessageId?: (messageId: number | null) => void
}

export const MessageWallContext = createContext({} as MessageWallContextProps)
